import React from 'react'
import ForgotPasswordComponent from '../Components/ForgotPasswordComponent'
import { LandingHeader } from '../../LandingScreens/Components/LandingHeader'

function ForgotPasswordPage() {
  return (
    <div>
      <LandingHeader />
      <ForgotPasswordComponent />
    </div>
  )
}

export default ForgotPasswordPage
